export class StudyImageInfo {
    Id?: number;
    imageUrl: string;
    imageName: string;
    imageFullPath: string;
    isSelected?: boolean;
}